export default function useScroll () {

  const getOffset = () => {
    let height = 0
    const adminBar = document.getElementById('wpadminbar')
    height += adminBar ? adminBar.getBoundingClientRect().height : 0
    height += getHeaderHeight()
    return height
  }

  const getHeaderHeight = () => {
    const screenWidth = getScreenWidth()
    if (screenWidth <= 580) {
      return 64
    }
    if (screenWidth <= 1160) {
      return 80
    }
    return 120
  }

  const scrollToContainer = (containerRef, bp = 0) => {
    if (!containerRef?.current || (bp > 0 && window.innerWidth > bp)) {
      return
    }

    const top = containerRef.current.getBoundingClientRect().top
    const offset = top + window.pageYOffset - getOffset()

    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    })
  }

  const getScreenWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }

  return {
    scrollToContainer
  }
}
